import React from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Button from 'epn-ui/umd/dist/components/Button';
import useI18n from '@i18n';

interface INeedToAddPlacementModal {
    isOpen: boolean;
    onClose: () => void;
}

const NeedToAddPlacementModal: React.FC<INeedToAddPlacementModal> = ({ onClose, isOpen }) => {
    const { t, locale } = useI18n('Offers');

    return (
        <Dialog onCancel={onClose} open={isOpen} size="sm">
            <div className="p-[8px] xs-[16px]">
                <p className="font-bold text-center text-[24px] leading-[35px]">
                    {t('Connect the placement')}
                </p>
                <p className="w-full text-center my-[24px]">
                    {t('To activate the offer, you need at least one allow placement')}
                </p>
                <Button
                    type="primary"
                    className="w-full"
                    href={`/${locale}/placements/add`}
                    target="_blank"
                >
                    {t('Connect an ad platform')}
                </Button>
            </div>
        </Dialog>
    );
};

export default NeedToAddPlacementModal;
